import axios from 'axios';
import TomSelect from 'tom-select';

declare let booking_object: any;

export default class getGames{ 

    /**
     * Get rooms
     * @returns 
     */
    get(el_games: string){
        
        // Settings
        const settings: any = {
            plugins: ['dropdown_input'],
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            preload: true,
            load: function (query, callback) {

                const q = {
                    'name': query
                }
    
                // Call ajax
                axios.post(booking_object.rest_urls.admin_get_games, '')
                    .then(function (response: any) {
    
                        callback(response.data);

                    })
                    .catch(function (error: any) {
    
                        console.log(error);
    
                    });
            },
            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">' + escape(item.name) + '</span>';
                },
                item: function (item, escape) {

                    return '<span class="block w-full fluid-text-xs">' + escape(item.name) + '</span>';
                },
            }
        };

        const control: TomSelect = new TomSelect(el_games, settings);
        
        return control;

    }

}